import React, { useContext, useEffect, useState } from "react";
import "./CoffeBox.css";
import MyContext from "../../../context/MyContext";
import { useInView } from 'react-intersection-observer';

interface CoffeeProps {
    data: {
        id: number;
        name: string;
        category: string[];
        kind: {
            type: string;
            description?: string;
            img: string;
        }[];
        price: string;
    };
    FilterCoffeeData: any;
}

const CoffeeBox: React.FC<CoffeeProps> = ({ data }) => {
    const [photoIndex, setPhotoIndex] = useState<number>(0);
    /* const [priceCounter, setPriceCounter] = useState<number>(0); for down */
    /* for this -> */  const [, setPriceCounter] = useState<number>(0);
    const [showMoreKind, setShowMoreKind] = useState<boolean>(false);
    const [showFullDescription, setShowFullDescription] = useState<boolean>(false);
    /* const { Coffee, setCoffee, Refrch, setRefrch } = useContext(MyContext)!; for down */
    /* for this -> */    const { Coffee } = useContext(MyContext)!;
    const showMore = data?.kind?.[0]?.description ? data.kind[0].description.split(" ") : [];


    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1
    });

    /*     const increment = () => {
            const uniqueKey = `${data.id}-${photoIndex}`;
            const index = Coffee.findIndex((coffee: any) => coffee.uniqueKey === uniqueKey);
    
            setPriceCounter((prevPriceCounter) => {
                const newPriceCounter = prevPriceCounter + 1;
                const item = {
                    uniqueKey: uniqueKey,
                    id: data.id,
                    Name: data.name,
                    category: data.category.length === 1 ? data.category[0] : data.category[1],
                    kind: data.kind[photoIndex],
                    price: data.price,
                    count: newPriceCounter,
                };
    
                if (index === -1) {
                    Coffee.push(item);
                } else {
                    Coffee[index] = item;
                }
    
                localStorage.setItem("DataCoffee", JSON.stringify(Coffee));
                return newPriceCounter;
            });
            setCoffee([...Coffee]);
            setRefrch(!Refrch);
        }; */

    /*     const decrement = () => {
            const uniqueKey = `${data.id}-${photoIndex}`;
            const index = Coffee.findIndex((coffee: any) => coffee.uniqueKey === uniqueKey);
    
            setPriceCounter((prevPriceCounter) => {
                const newPriceCounter = prevPriceCounter > 0 ? prevPriceCounter - 1 : 0;
                if (index !== -1) {
                    if (newPriceCounter > 0) {
                        Coffee[index].count = newPriceCounter;
                    } else {
                        Coffee.splice(index, 1);
                    }
                    localStorage.setItem("DataCoffee", JSON.stringify(Coffee));
                }
                return newPriceCounter;
            });
            setCoffee([...Coffee]);
            setRefrch(!Refrch);
        }; */

    useEffect(() => {
        setPhotoIndex(0);
    }, [data]);

    useEffect(() => {
        const uniqueKey = `${data.id}-${photoIndex}`;
        const index = Coffee.findIndex((ele: any) => ele.uniqueKey === uniqueKey);
        if (index !== -1) {
            setPriceCounter(Coffee[index].count);
        } else {
            setPriceCounter(0);
        }
    }, [data.id, photoIndex, Coffee]);

    useEffect(() => {
        data.kind.length > 3 ? setShowMoreKind(true) : setShowMoreKind(false);
    }, [data.kind.length]);

    const truncateDescription = (description: string | undefined) => {
        if (!description) return "";
        const words = description.split(" ");
        if (words.length > 10) {
            return words.slice(0, 5).join(" ") + "...";
        }
        return description;
    };
   

    useEffect(() => {
        setShowFullDescription(false)
    }, [data]);


    return (
        <div className={`coffee-box show-to-up ${inView ? 'fade-in' : ''}`} ref={ref}>
            <div className="img-content" id={data?.category.includes("حلويات") || data?.category.includes("وجبات") ? "no-out-img" : ""}>
                <img src={data.kind[photoIndex]?.img} loading="lazy" alt="" />
            </div>
            <div className="coffee-info">
                <div className="title">
                    <div className="head">
                        <h2>{data.name}</h2>
                    </div>
                    <ul>
                        {showMoreKind ?
                            (data.kind.slice(0, 3).map((kind, index) => {
                                return <li
                                    key={index}
                                    className={index === photoIndex ? "active" : undefined}
                                    onClick={() => setPhotoIndex(prev => index)}
                                >
                                    {kind.type}
                                </li>
                            })) : (
                                data.kind.map((kind, index) => (
                                    <li
                                        key={index}
                                        className={index === photoIndex ? "active" : undefined}
                                        onClick={() => setPhotoIndex(index)}
                                    >
                                        {kind.type}
                                    </li>
                                ))
                            )}
                        {data.kind.length > 3 ?
                            showMoreKind ? <p onClick={() => {
                                setShowMoreKind(false)
                            }}> المزيد</p> : <p onClick={() => {
                                setShowMoreKind(true)
                            }}> اقل</p> : undefined}
                    </ul>
                </div>
                <div className="description">
                    <p>
                        {showFullDescription
                            ? data.kind[photoIndex]?.description
                            : truncateDescription(data.kind[photoIndex]?.description)}
                        <span
                            className="show-more"
                            onClick={() => setShowFullDescription(!showFullDescription)}
                        >
                            {showMore.length > 10 ? showFullDescription ? " أقل" : " المزيد" : ""}
                        </span>
                    </p>
                </div>
                <div className="price">
                                        
                                        {data?.price !== "0" ? <p><span>{data?.price} </span>  ريال</p> : null
                                        }
                    {/* <div className="add">
                        <ul>
                            <li onClick={increment}>+</li>
                            <li>{priceCounter}</li>
                            <li onClick={decrement}>-</li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default CoffeeBox;
